import React, { useEffect, useState } from "react";
import { Layers } from "lucide-react";
import api from "@/lib/api";
import { CallCard } from "@/components/calls/CallCard";

export default function MyCalls() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/calls").then((r) => setData(r.data)).catch(() => setData({ cards: [] })); }, []);
  if (!data) return <div className="p-8 text-tc-muted font-mono text-sm">Loading your calls…</div>;
  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-6xl mx-auto space-y-5" data-testid="my-calls-page">
      <div>
        <div className="text-[11px] font-mono uppercase tracking-widest text-tc-xp flex items-center gap-1.5"><Layers className="w-3.5 h-3.5" /> My Calls</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold mt-1">Calls you made and stood behind</h1>
        <p className="text-sm text-tc-sub mt-2 max-w-2xl" data-testid="my-calls-note">
          Each card is earned by a passed Boss challenge, or a top-grade historical scenario with your reasoning written at the moment of the call. {data.note} Only you can see this collection.
        </p>
      </div>
      {data.cards.length === 0 ? (
        <div className="tc-card p-6 text-sm text-tc-sub" data-testid="my-calls-empty">
          No cards yet. Pass a Boss challenge, or earn a top grade on a historical scenario, and write a short "why" when you make the call.
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3" data-testid="my-calls-grid">
          {data.cards.map((c) => <CallCard key={c.id} card={c} />)}
        </div>
      )}
    </div>
  );
}
